/**
 * Listing Title DOM Component
 *
 * Creates and manages the H4 title element for the listing sheet panel.
 * Text is set by the owning plugin; this component owns no state.
 *
 * @module nativeInteractiveSiteMap/components/listingTitle.dom
 */

import fastdom from 'fastdom';

export default function createListingTitle() {
  const element = document.createElement('h4');
  element.className = `nhs-c-native-interactive-site-map__panel-title nhs-mq-native-interactive-site-map__panel-title-medium nhs-o-typography--souvenir-subhead-1-large-light`;
  element.setAttribute('data-qa', 'native_ism_sidepanel_title');
  return {
    getElement() {
      return element;
    },
    setText(text) {
      element.textContent = text;
    },
    remove() {
      fastdom.mutate(() => {
        element.remove();
      });
    },
  };
}
